// https://vike.dev/onCreateApp
export { onCreateApp };

import type { OnCreateAppSync } from 'vike-vue/types';
import { connectLogger, createCtx } from '@reatom/framework';
import { createReatomVue } from '@reatom/npm-vue';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ConfirmationService from 'primevue/confirmationservice';

const onCreateApp: OnCreateAppSync = (
  pageContext,
): ReturnType<OnCreateAppSync> => {
  if (pageContext.isRenderingHead) return;

  const { app } = pageContext;

  // Reatom
  const reatomCtx = createCtx();
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    connectLogger(reatomCtx);
  }
  app.use(createReatomVue(reatomCtx));

  // PrimeVue
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
    },
  });
  app.use(ConfirmationService);
};
